<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>
      {{ name }}
    </template>
    <template v-slot:body>
      <div class="text-center body-1">
        <v-img :src="imagePath"
               max-height="64"
               class="ma-auto"
               contain
        />
        <p class="mt-6" v-html="description"></p>
        <a :href="website" target="_blank">Visit Plugin Website</a>
      </div>
    </template>
    <template v-slot:actions>
      <gg-btn primary class="mx-auto" @click="close">
        Close
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
export default {
  name: 'PluginDialog',
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imagePath: {
      type: String,
      required: true
    },
    website: {
      type: [String, Boolean],
      default: false
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
